(function () {
  'use strict';


  /* ======================================================
     REVEAL ANIMATIONS
  ====================================================== */

  function initRevealAnimations(root) {
    const elements =
      root.querySelectorAll('.demiz-home-reveal');


    if (
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) {
      elements.forEach(function (element) {
        element.classList.add('demiz-visible');
      });

      return;
    }


    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (element) {
        element.classList.add('demiz-visible');
      });

      return;
    }


    const observer =
      new IntersectionObserver(
        function (entries) {

          entries.forEach(function (entry) {

            if (entry.isIntersecting) {

              entry.target.classList.add(
                'demiz-visible'
              );

              observer.unobserve(
                entry.target
              );

            }

          });

        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -35px 0px'
        }
      );


    elements.forEach(function (element) {
      observer.observe(element);
    });
  }



  /* ======================================================
     TRUE INFINITE MARQUEE
  ====================================================== */

  function buildMarquee(marquee) {

    const track =
      marquee.querySelector(
        '.demiz-home-marquee-track'
      );


    const group =
      marquee.querySelector(
        '.demiz-home-marquee-group:not([data-demiz-clone])'
      );


    if (!track || !group) {
      return;
    }


    /*
      Save original content once
    */

    if (!group.dataset.originalHtml) {
      group.dataset.originalHtml =
        group.innerHTML.trim();
    }


    /*
      Stop previous animation
    */

    if (track._demizAnimation) {
      track._demizAnimation.cancel();
      track._demizAnimation = null;
    }


    /*
      Remove previous clone
    */

    track
      .querySelectorAll('[data-demiz-clone]')
      .forEach(function (clone) {
        clone.remove();
      });


    /*
      Restore one original item
    */

    group.innerHTML =
      group.dataset.originalHtml;


    /*
      Reset transform before measuring
    */

    track.style.transform =
      'translate3d(0, 0, 0)';


    /*
      Fill the group until it is wider
      than the visible marquee area.

      We intentionally make it significantly
      wider than the viewport to guarantee
      there can never be an empty gap.
    */

    const marqueeWidth =
      marquee.getBoundingClientRect().width;


    const targetWidth =
      marqueeWidth + 500;


    let safety = 0;


    while (
      group.getBoundingClientRect().width <
        targetWidth &&
      safety < 50
    ) {

      group.insertAdjacentHTML(
        'beforeend',
        group.dataset.originalHtml
      );

      safety++;
    }


    /*
      Create exact copy of completed group
    */

    const clone =
      group.cloneNode(true);


    clone.dataset.demizClone = 'true';

    clone.setAttribute(
      'aria-hidden',
      'true'
    );


    track.appendChild(clone);


    /*
      Measure exact width of first group
    */

    const groupWidth =
      group.getBoundingClientRect().width;


    if (!groupWidth) {
      return;
    }


    /*
      Movement speed

      Higher number = faster.
      Lower number = slower.
    */

    const pixelsPerSecond = 55;


    const duration =
      (groupWidth / pixelsPerSecond) * 1000;


    /*
      Native browser animation.

      Move EXACTLY one group width.

      When the animation restarts,
      group 2 is visually identical
      to group 1, so the reset is invisible.
    */

    track._demizAnimation =
      track.animate(
        [
          {
            transform:
              'translate3d(0, 0, 0)'
          },

          {
            transform:
              'translate3d(-' +
              groupWidth +
              'px, 0, 0)'
          }
        ],
        {
          duration: duration,
          iterations: Infinity,
          easing: 'linear'
        }
      );

  }



  /* ======================================================
     INITIALIZE ALL MARQUEES
  ====================================================== */

  function initMarquees(root) {

    const marquees =
      root.querySelectorAll(
        '[data-demiz-marquee]'
      );


    marquees.forEach(function (marquee) {
      buildMarquee(marquee);
    });

  }



  /* ======================================================
     INITIALIZE HOME
  ====================================================== */

  function initDemizHome(root) {

    if (!root) {
      return;
    }


    if (
      root.dataset.demizRevealInitialized !==
      'true'
    ) {

      root.dataset.demizRevealInitialized =
        'true';

      initRevealAnimations(root);

    }


    initMarquees(root);

  }



  function initAllDemizHomes(scope) {

    const context =
      scope || document;


    const homes =
      context.querySelectorAll(
        '[data-demiz-home]'
      );


    homes.forEach(function (home) {
      initDemizHome(home);
    });

  }



  /* ======================================================
     INITIAL PAGE LOAD
  ====================================================== */

  function startDemizHome() {

    initAllDemizHomes(document);

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      startDemizHome
    );

  } else {

    startDemizHome();

  }



  /* ======================================================
     SHOPIFY THEME EDITOR
  ====================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initAllDemizHomes(
        event.target
      );

    }
  );



  /* ======================================================
     WINDOW RESIZE
  ====================================================== */

  let resizeTimer;


  window.addEventListener(
    'resize',
    function () {

      clearTimeout(resizeTimer);


      resizeTimer =
        setTimeout(
          function () {

            document
              .querySelectorAll(
                '[data-demiz-home]'
              )
              .forEach(function (home) {

                initMarquees(home);

              });

          },
          200
        );

    }
  );

})();